import { render, staticRenderFns } from "./OrganizerOverview.vue?vue&type=template&id=4fbed2fe&"
import script from "./OrganizerOverview.vue?vue&type=script&lang=js&"
export * from "./OrganizerOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports